module.exports = __webpack_public_path__ + "img/about3.09342840.png";